import Roles from '@/auth/roles';
import TournamentForm from './tournament-form';
import TournamentList from './tournament-list';
import TournamentHistoryFull from './tournament-history/tournament-history-full/tournament-history-full';
import TournamentHistorySingle from './tournament-history/tournament-history-single/tournament-history-single';
import TournamentShow from './tournament-show';
import TournamentSettings from './tournament-settings';
import SettingGroups from './setting-groups/setting-groups';

const roles = Roles.values;

export default [
  {
    name: 'tournamentList',
    path: 'tournament',
    component : TournamentList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.tournamentViewer.id,
        roles.tournamentEditor.id
      ]
    }
  },
  {
    name: 'tournamentNew',
    path: 'tournament/new',
    component: TournamentForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.tournamentEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'tournamentEdit',
    path: 'tournament/:id/edit',
    component: TournamentForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.tournamentEditor.id
      ]
    }
  },
  {
    name: 'tournamentHistorySingle',
    path: 'tournament/:id/history',
    component: TournamentHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'tournamentHistoryFull',
    path: 'tournament/history',
    component: TournamentHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'tournamentShow',
    path: 'tournament/:id',
    component: TournamentShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.tournamentViewer.id,
        roles.tournamentEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'tournamentSettings',
    path: 'tournament/settings/:id',
    component: TournamentSettings,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.tournamentViewer.id,
        roles.tournamentEditor.id,
        roles.clubManager.id
      ]
    },
    children: [
      {
        name: 'settingGroups',
        path: 'settingGroups/:categoryId',
        component: SettingGroups,
        props: true,
        meta: { auth: true },
      },
    ],
  }
];



// WEBPACK FOOTER //
// ./src/entities/tournament/tournament-routes.js